var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000135681600193391720410000016501451154193627804_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_23.Question",
    d: "m256.8 0c-142-.4-257.2 114.8-256.8 256.8.4 140.4 117.5 255.2 257.9 255.2h254.1v-254.1c0-140.4-114.8-257.5-255.2-257.9zm22 386.4c-6.7 5.9-15 8.9-25 8.9s-18.3-3-25-8.9-10-13.5-10-22.7 3.3-16.8 10-22.7 15-8.9 25-8.9 18.3 3 25 8.9 10 13.5 10 22.7-3.4 16.7-10 22.7zm59.2-167.3c-4.1 8.5-10.7 17.2-19.8 26l-21.5 20c-6.1 5.9-10.4 11.9-12.7 18.1-2.4 6.2-3.7 14-3.9 23.5h-53.6c0-18.2 2.1-32.6 6.2-43.1 4.2-10.7 11.1-20.1 20-27.4 9.2-7.7 16.3-14.8 21.1-21.2 4.7-6.1 7.2-13.6 7.2-21.2 0-18.8-8.1-28.3-24.3-28.3-7-.2-13.7 2.8-18.1 8.2-4.6 5.5-7.1 12.9-7.3 22.3h-63.2c.3-25 8.1-44.4 23.6-58.3s37.2-20.9 65.1-20.9c27.8 0 49.4 6.4 64.7 19.3s22.9 31.1 22.9 54.8c-.1 9.7-2.2 19.4-6.4 28.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReview);
export default __webpack_public_path__ + "static/media/icon-review.9b55d11490196ff4addabd8ad6b0a3bf.svg";
export { ForwardRef as ReactComponent };